const htmlSanitizer = htmlsanitizer;
htmlSanitizer.AllowedTags['INPUT'] = true;
htmlSanitizer.AllowedTags['ARTICLE'] = true;
htmlSanitizer.AllowedTags['PICTURE'] = true;
htmlSanitizer.AllowedTags['SELECT'] = true;
htmlSanitizer.AllowedTags['OPTION'] = true;
htmlSanitizer.AllowedTags['svg'] = true;
htmlSanitizer.AllowedTags['use'] = true;
htmlSanitizer.AllowedTags['SECTION'] = true;
htmlSanitizer.AllowedTags['BUTTON'] = true;
htmlSanitizer.AllowedTags['FIGURE'] = true;
htmlSanitizer.AllowedTags["FIGCAPTION"] = true;

htmlSanitizer.AllowedAttributes['class'] = true;
htmlSanitizer.AllowedAttributes['type'] = true;
htmlSanitizer.AllowedAttributes['value'] = true;
htmlSanitizer.AllowedAttributes['name'] = true;
htmlSanitizer.AllowedAttributes['data-src'] = true;
htmlSanitizer.AllowedAttributes['data-srcset'] = true;
htmlSanitizer.AllowedAttributes['data-url'] = true;
htmlSanitizer.AllowedAttributes['xmlns:xlink'] = true;
htmlSanitizer.AllowedAttributes['xlink:href'] = true;
htmlSanitizer.AllowedAttributes['placeholder'] = true;
htmlSanitizer.AllowedAttributes['data-filter'] = true;
htmlSanitizer.AllowedAttributes['selected'] = true;
htmlSanitizer.AllowedAttributes['data-container-id'] = true;
htmlSanitizer.AllowedAttributes['data-type'] = true;
htmlSanitizer.AllowedAttributes['srcset'] = true;
htmlSanitizer.AllowedAttributes['colspan'] = true;

htmlSanitizer.AllowedAttributes['data-taxon-component'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-clickable_tile-title'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-clickable_tile-contentid'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-clickable_tile-display'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-button-title'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-button-contentid'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-button-display'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-dropdown-title'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-dropdown-contentid'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-dropdown-display'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-parent'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-eventlistitem-title'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-eventlistitem-contentid'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-eventlistitem-display'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-specific-list-title'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-specific-list-contentid'] = true;
htmlSanitizer.AllowedAttributes['data-taxon-specific-list-display'] = true;
htmlSanitizer.AllowedAttributes['data-all-results-tab'] = true;
htmlSanitizer.AllowedAttributes['data-solutions-tab'] = true;
htmlSanitizer.AllowedAttributes['data-articles-tab'] = true;
htmlSanitizer.AllowedAttributes['data-tools-tab'] = true;